import { defaultGetAction } from '../../utils';

import { GET_VACANCIES } from './constants';

export const loadVacancies = defaultGetAction(GET_VACANCIES, 'job_vacancies/');



// WEBPACK FOOTER //
// ./src/redux/Vacancies/actions.js